import { benchShapes, benchModels, stoves } from '../config.js'
import benchShapeFilter from '../helpers/benchShapeFilter';



let buildDefaultAvailableBenchShapes = (useAllShapes) => {
    let result = {};
    benchModels.forEach(m => {
        result[m.name] = (!useAllShapes || !m.allShapesPossilbe) ? m.availableShapes : benchShapes;
    });
    return result;
}

var initialState =
{
    model: benchModels[1],
    availableBenchModels: [benchModels[1], benchModels[0], benchModels[2], benchModels[5], benchModels[4]],
    availableModelSpecificBenchShapes: buildDefaultAvailableBenchShapes(),
    availableBenchShapes: benchModels[1].availableShapes,
    unavailableBenchShapes: [],
    shape: benchShapes[7],
    stove: stoves[0].id,
    imageComponents: {},
    mirrored:false
}

const benchModel = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_MODEL':
            let availableBenchShapes = state.availableModelSpecificBenchShapes[action.model.name]
            return Object.assign({}, state, {
                model: action.model,
                availableBenchShapes: availableBenchShapes,
                unavailableBenchShapes: [],
                shape: availableBenchShapes.find(s => state.shape.code == s.code) ? state.shape : availableBenchShapes[0],
                material: action.material,
                profileMaterial: action.profileMaterial
            })
        case 'CHANGE_SHAPE':
            return Object.assign({}, state, {
                shape: action.shape
            })
        case 'CHANGE_BENCH_MATERIAL':
            return Object.assign({}, state, {
                material: action.id
            })
        case 'MIRROR_BENCH':
            return Object.assign({}, state, {
                mirrored: !state.mirrored
            })
        case 'CHANGE_PROFILE_MATERIAL':
            return Object.assign({}, state, {
                profileMaterial: action.id
            })
        case 'STOVE_CHANGED':
            return Object.assign({}, state, {
                stove: action.stove
            })
        case 'AVAILABLE_STOVES_CHANGED':
            if (action.stoves.filter(s => s.name === state.stove.id).length === 0) {
                return Object.assign(
                    {}, state, {
                        stove: action.stoves[0]
                    })
            }
            else {
                return state;
            }
        case 'BENCHCADIMAGE_RENDERCOMPLETE':
            return Object.assign({}, state, {
                cadImage: action.image,
                cadImageScale: action.scale
            })
        case 'BENCH_IMAGECOMPONENTS_UPDATED':
            return Object.assign({}, state, {
                imageComponents: action.components
            })
        case 'PLAN_LOADED':
            let availableModelSpecificBenchShapes =
                (action.plan.clientConfiguration) ?
                    buildShapesFromConfiguration(action.plan.clientConfiguration.availableBenchShapes) :
                    state.availableModelSpecificBenchShapes;
            let shapes =     availableModelSpecificBenchShapes[action.plan.benchBrand] || benchShapes
            return Object.assign({}, state, {
                stove: (stoves.find(s => s.exportID === action.plan.Stove) || stoves[0]).id,
                availableBenchModels: (action.plan.clientConfiguration) ? benchModels.filter(b => action.plan.clientConfiguration.availableBenchShapes.map(m => m.benchBrand).includes(b.name)) : benchModels,
                availableModelSpecificBenchShapes: availableModelSpecificBenchShapes,
                availableBenchShapes: availableModelSpecificBenchShapes[action.plan.benchBrand],
                unavailableBenchShapes: [],
                model: benchModels.find(m => m.name === action.plan.benchBrand),
                shape: shapes.find(m => m.code === action.plan.benchShape),
                material: action.plan.benchMaterial,
                profileMaterial: action.plan.curvedPieces
            })
        case 'CLIENT_COFIGURATION_UPDATED':
      
            let availableModelSpecificBenchShapes2 = buildDefaultAvailableBenchShapes(action.configuration.displayAllShapes);
            let availableBenchShapes2 = availableModelSpecificBenchShapes2[state.model.name]
            let nextState = {
                availableModelSpecificBenchShapes: availableModelSpecificBenchShapes2,
                availableBenchShapes: availableBenchShapes2,
                unavailableBenchShapes: []
            };
            let avalaibleBenchModels = action.configuration.avalaibleBenhcModels;
            if (avalaibleBenchModels) {
                nextState.availableBenchModels = avalaibleBenchModels;
            }
            return Object.assign({}, state, nextState);
        case 'FILTER_SHAPES':
            let filteRersult = new benchShapeFilter().filterShapes(state.shape, state.availableModelSpecificBenchShapes[state.model.name], action.measurements);
            return Object.assign({}, state, {
                availableBenchShapes: filteRersult.availableShapes,
                unavailableBenchShapes: filteRersult.unavailableShapes,
                shape: filteRersult.shape
            })           

        default:
            return state;
    }
}
export default benchModel

let buildShapesFromConfiguration = (configuration) => {
    let result = {};
    configuration.forEach(m => result[m.benchBrand] = m.models.map(s => buildShape(s)));
    return result;
}
let buildShape = (shape) => {
    let r = Object.assign({}, benchShapes.find(s => s.code === shape.imageCode));
    r.mirrored = shape.mirrored;
    r.numberOfBenchLightFibersNeeded = shape.numberOfBenchLightFibersNeeded;
    return r;
}
